// @flow

import React from "react";
import { Input } from "reactstrap";
import classNames from "classnames";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import { BaseInput as BaseInputProps } from "react-jsonschema-form/lib/components/widgets/BaseInput";

type Props = $Exact<{
  ...BaseInputProps,
  options: Object,
}>;

export class NumberInputWidget extends React.Component<Props> {
  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value) ? +event.currentTarget.value : this.props.value,
    );
  };
  render() {
    const props = {
      ...this.props,
      ...this.props.options,
      ...(this.props.schema && this.props.schema.hasOwnProperty("minimum")
        ? { min: this.props.schema.minimum }
        : {}),
      ...(this.props.schema && this.props.schema.hasOwnProperty("maximum")
        ? { max: this.props.schema.maximum }
        : {}),
      onChange: this.handleChange,
    };

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;
    delete props.options;
    delete props.label;
    delete props.labelposition;
    delete props.enumOptions;
    delete props.editable;

    return (
      <React.Fragment>
        <Input
          type="number"
          {...props}
          value={props.value || ""}
          className={classNames("mt-1", this.props.className)}
        />
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default NumberInputWidget;
